import type { WithUnknownProperties } from '@schibsted-nmp/advertising-shared';

import type { Pbjs } from '../Pbjs.js';

export type PrebidRequester = WithUnknownProperties<{
  readonly byBidderInfo: PrebidRequester.ByBidderInfo;
  readonly siteData: PrebidRequester.SiteData;
  readonly pbjs: Pbjs;
}>;

export namespace PrebidRequester {
  export type ByBidderInfo = {
    readonly [alias: string]: ByBidderInfo.Value;
  };

  export namespace ByBidderInfo {
    export type Value = WithUnknownProperties<{
      readonly id: string;
    }>;
  }

  export type SiteData = WithUnknownProperties<{
    readonly sspCustomSettings?: SiteData.SspCustomSettings;
  }>;

  export namespace SiteData {
    export type SspCustomSettings = {
      readonly [sspId: string]: SspCustomSettings.Value;
    };

    export namespace SspCustomSettings {
      export type Value = {
        readonly bidderCodeOrAlias: string | null;
        readonly revenueFactor?: number | null;
        readonly schainNodes?: ReadonlyArray<Value.SchainNode> | null;
        readonly consentExcepted?: boolean | null;
        readonly sspType?: Value.SspType | null;
      };

      export namespace Value {
        export type SchainNode = WithUnknownProperties<{
          readonly asi: string;
          readonly sid: string;
          readonly hp: number;
        }>;

        export const SspTypes = {
          DIRECT: 'DIRECT',
          RESELLER: 'RESELLER'
        };

        export type SspType = (typeof SspTypes)[keyof typeof SspTypes];
      }
    }
  }
}
